import React from "react";
import ellipse from "../assets/images/Ellipse 1.png";
import { Icon } from "@iconify/react";
export const Cinematic = () => {
  return (
    <>
      <div className="h-[40vh] lg:h-[100vh] lg:w-[60%] mx-auto text-white">
        <video
          autoPlay
          loop
          muted
          playsInline
          controls
          className="object-cover"
        >
          <source src="Season-1_Oceanic.mp4" type="video/mp4" />
          {/* You can add additional source elements for other video formats (e.g., WebM, Ogg) if needed */}
          Your browser does not support the video tag.
        </video>
      </div>

      {/* <div className="text-center h-[100px] relative mt-[40px]">
        <h1
          className="font-bold text-white text-[20px] tracking-[3px] md:tracking-[10px] absolute bottom-0 left-[50%]"
          style={{ transform: "translateX(-50%)" }}
        >
          Coming Soon
        </h1>
      </div> */}

      {/* ======================= */}
      <div className="text-white text-center font-bold text-[35px] sm:text-[45px] md:text-[60px] mb-[25px]">
        ROADMAP
      </div>
      <div className=" flex items-center justify-center text-white sword pt-[50%]">
        <div className="text-center sword_inner_div "></div>
        <div className="sword_inner_div2"></div>
        <div className="red-1"></div>
        <div className="red-2"></div>
        <div class="red-3"></div>
        <div class="bg-1-mb"></div>
        <div class="bg-2-mb"></div>
        <div className="centent-collect text-center font-[700] w-[100%] lg:w-[70%] text-[40px] md:text-[70px] xl:text-[50px]">
          Collect, Learn,
          <br />
          Summon, Fight, Win.
        </div>
        <div className="block lg:flex items-center justify-center lg:gap-[100px] absolute z-[999] lg:z-[5] top-[400px] lg:top-[700px] bottom-[0px]">
          <div className="roadmap-card w-[250px] h-[320px] lg:h-[370px]  items-center justify-center font-bold text-[black] text-[27px]">
            <div className="flex items-center justify-center pt-[70px] lg:pt-[unset] mt-[80px] text-center">
              <Icon className="text-[50px]" icon="icon-park-solid:owl" />
            </div>
            <div className="text-center mt-[10px]">
              <div className="mb-2">Q4-2023</div>
              <div className="text-black text-[16px]">
                Marketing <br />
                Token Presale <br />
                Game Alpha release <br />
                NFT collection
              </div>
            </div>
            {/* <img width="140px" src={ellipse} alt="" /> */}
          </div>
          <div className="roadmap-card w-[250px] h-[320px] lg:h-[370px]  items-center justify-center font-bold text-[black] text-[27px]">
            <div className="flex items-center justify-center pt-[70px] lg:pt-[unset] mt-[80px] text-center">
              <Icon className="text-[50px] " icon="icon-park-solid:owl" />
            </div>
            <div className="text-center mt-[10px]">
              <div className="mb-2">Q1-2024</div>
              <div className="text-black text-[16px]">
                Game Beta <br />
                List on TIER 1 CEXs <br />
                Mobile version <br />
                Land creation
              </div>
            </div>
            {/* <img width="140px" src={ellipse} alt="" /> */}
          </div>
          <div className="roadmap-card w-[250px] h-[320px] lg:h-[370px]  items-center justify-center font-bold text-[black] text-[27px]">
            <div className="flex items-center justify-center pt-[70px] lg:pt-[unset] mt-[80px] text-center">
              <Icon className="text-[50px]" icon="icon-park-solid:owl" />
            </div>
            <div className="text-center mt-[10px]">
              <div className="mb-2">Q2-2024</div>
              <div className="text-black text-[16px]">
                Full game release <br />
                Launch on Epic Games STORE <br />
                Free to play version <br />
                Adding more features
              </div>
            </div>
            {/* <img width="140px" src={ellipse} alt="" /> */}
          </div>
        </div>

        <button
          type="button"
          className="link-button hidden rounded-full w-[85%] sm:w-[80%] px-4 md:w-[90%] xl:w-[41%] py-4 text-[10px] sm:text-[12px] md:text-[14px] xl:text-[20px] font-bold text-white bg-transparent shadow-sm ring-2 ring-inset ring-[#7C0B0B] tracking-[2px] md:tracking-[5px]"
        >
          SELECT YOUR CHAMPION AND PLAY NOW
        </button>
        <div class="home-page-fade-big-bottom"></div>
      </div>
    </>
  );
};
